<div class="table-container">
  <table
    [formGroup]="formGroup"
    appScrollToInvalidControl
    #toInvalid="appScrollToInvalidControl"
  >
    <thead>
      <tr
        class="mat-header-row caption-row"
        *ngIf="showCaptionRow"
        [class.has-sub-table]="formArray.length"
      >
        <th class="mat-header-cell">
          <mat-checkbox
            class="easy-checkbox"
            [checked]="(isAllGivenMerchantsSelected$ | async) !== 'NOT_CHECKED'"
            [indeterminate]="
              (isAllGivenMerchantsSelected$ | async) === 'INDETERMINATE'
            "
            #groupOfGroupsCheckbox
            (change)="
              toggleAllMerchants(
                groupOfGroupsCheckbox.indeterminate
                  ? true
                  : groupOfGroupsCheckbox.checked
              )
            "
          >
          </mat-checkbox>
        </th>
        <th class="mat-header-cell">
          {{ "VIP_DISCOUNTS.SETTINGS.PRODUCT" | translate }}
        </th>
        <th class="mat-header-cell">
          {{ "VIP_DISCOUNTS.SETTINGS.DISCOUNT" | translate }}
        </th>
        <th class="mat-header-cell">
          {{ "VIP_DISCOUNTS.SETTINGS.VIEW_ORIGINAL_PRICE" | translate }}
        </th>
        <th class="mat-header-cell">
          {{ "VIP_DISCOUNTS.SETTINGS.DATE_FROM" | translate }}
        </th>
        <th class="mat-header-cell">
          {{ "VIP_DISCOUNTS.SETTINGS.DATE_TO" | translate }}
        </th>
        <th class="mat-header-cell"></th>
      </tr>
      <tr class="mat-header-row title-row sub-header" *ngIf="formArray.length">
        <th class="mat-header-cell checkboxes-header">
          <mat-checkbox
            class="easy-checkbox"
            #groupCheckbox
            [checked]="
              (isMerchantAllGivenProductsSelected$ | async) !== 'NOT_CHECKED'
            "
            [indeterminate]="
              (isMerchantAllGivenProductsSelected$ | async) === 'INDETERMINATE'
            "
            (change)="
              toggleAll(
                groupCheckbox.indeterminate ? true : groupCheckbox.checked
              )
            "
          >
          </mat-checkbox>
        </th>
        <th class="mat-header-cell">
          {{ originalValue.companyName }}
        </th>
        <th class="mat-header-cell"></th>
        <th class="mat-header-cell"></th>
        <th class="mat-header-cell"></th>
        <th class="mat-header-cell"></th>
        <th class="mat-header-cell"></th>
        <th class="mat-header-cell"></th>
      </tr>
    </thead>

    <tbody formArrayName="vipDiscountList" *ngIf="formArray">
      <tr
        *ngFor="let group of formArray.controls; let index = index"
        [formGroupName]="index"
        class="mat-row"
      >
        <td class="mat-cell checkboxes-column">
          <mat-checkbox
            #cbx
            class="me-2 easy-checkbox"
            (change)="
            toggle(originalValue.vipDiscountList?.[index]?.discountId ?? '')
          "
            [checked]="
            isProductChecked(
              originalValue.vipDiscountList?.[index]?.discountId ?? ''
            )
          "
          >
          </mat-checkbox>
        </td>
        <td class="mat-cell">
          {{ formArray.at(index).get("packagingUnitLabel")?.value }}
        </td>
        <td class="mat-cell">
          <span *ngIf="!editingRowIndexes.includes(index); else valueForm">
            {{ formArray.at(index).get("discountValue")?.value | number }}
            {{
              "VIP_DISCOUNTS." + formArray.at(index).get("discountMode")?.value
                | translate
            }}
          </span>
          <ng-template #valueForm>
            <div class="discount-cell easy-form">
              <mat-form-field class="value-field">
                <app-easy-input
                  formControlName="discountValue"
                  type="number"
                  [maxDecimals]="2"
                  [min]="0"
                  [max]="
                    formArray.at(index).get('discountMode')?.value === 'PERCENT'
                      ? 100
                      : undefined
                  "
                ></app-easy-input>
              </mat-form-field>
              <mat-form-field>
                <app-easy-select
                  formControlName="discountMode"
                  [options]="discountModeOptions"
                  [labelAttribute]="'label'"
                  [valueAttribute]="'value'"
                  [hasEmptyOption]="false"
                  (ngModelChange)="discountModeChanged(index)"
                ></app-easy-select>
              </mat-form-field>
            </div>
          </ng-template>
        </td>
        <td class="mat-cell">
          <button
            mat-stroked-button
            color="primary"
            type="button"
            (click)="showOriginalPrice(index)"
            [disabled]="editingRowIndexes.includes(index)"
          >
            {{ "VIP_DISCOUNTS.SETTINGS.VIEW_ORIGINAL_PRICE" | translate }}
          </button>
        </td>
        <td class="mat-cell ps-4">
          <span *ngIf="!editingRowIndexes.includes(index); else startDateForm">
            {{
              formArray.at(index).get("startDate")?.value | date: "YYYY.MM.dd."
            }}
          </span>
          <ng-template #startDateForm>
            <div class="easy-form">
              <mat-form-field>
                <div class="form-field-container">
                  <input
                    formControlName="startDate"
                    [matDatepicker]="pickerFrom"
                    class="suffix"
                    matInput
                    (focus)="pickerFrom.open()"
                  />
                  <span matSuffix (click)="pickerFrom.open()">
                    <mat-icon>today</mat-icon>
                  </span>
                  <mat-datepicker #pickerFrom></mat-datepicker>
                </div>
              </mat-form-field>
            </div>
          </ng-template>
        </td>
        <td class="mat-cell">
          <span *ngIf="!editingRowIndexes.includes(index); else endDateForm">
            {{
              (formArray.at(index).get("endDate")?.value
                | date: "YYYY.MM.dd.") === cancellationMockDateHu
                ? ("VIP_DISCOUNTS.GIVEN.UNTIL_CANCELLATION" | translate)
                : (formArray.at(index).get("endDate")?.value
                  | date: "YYYY.MM.dd.")
            }}
          </span>
          <ng-template #endDateForm>
            <div class="easy-form">
              <mat-form-field>
                <div class="form-field-container">
                  <input
                    formControlName="endDate"
                    [matDatepicker]="pickerTo"
                    class="suffix"
                    matInput
                    [min]="
                      formArray.at(index).get('startDate')?.value
                        ? formArray.at(index).get('startDate')?.value
                        : today
                    "
                    (focus)="pickerTo.open()"
                  />
                  <span matSuffix (click)="pickerTo.open()">
                    <mat-icon>today</mat-icon>
                  </span>
                  <mat-datepicker #pickerTo></mat-datepicker>
                </div>
              </mat-form-field>
            </div>
          </ng-template>
        </td>
        <td class="mat-cell">
          <div class="actions-cell">
            <ng-container
              *ngIf="!editingRowIndexes.includes(index); else editingRowButtons"
            >
              <button
                mat-icon-button
                class="stroked"
                type="button"
                color="primary"
                (click)="editRow(index)"
                [matTooltip]="'VIP_DISCOUNTS.GIVEN.EDIT' | translate"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                class="stroked"
                type="button"
                color="warn"
                (click)="deleteRow(index)"
                [matTooltip]="'VIP_DISCOUNTS.GIVEN.DELETE' | translate"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </ng-container>
            <ng-template #editingRowButtons>
              <button
                mat-icon-button
                class="stroked"
                type="button"
                color="primary"
                (click)="
                  toInvalid.scrollToFirstInvalidControl(); saveRow(index)
                "
                [matTooltip]="'SHARED.SAVE' | translate"
              >
                <mat-icon>done</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                class="stroked"
                (click)="cancelRowEdit(index)"
                [matTooltip]="'SHARED.CANCEL' | translate"
              >
                <mat-icon>close</mat-icon>
              </button>
            </ng-template>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
